
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"11","viewBox":"0 0 16 11","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M11.375 5.25a1.87 1.87 0 001.867-1.875A1.87 1.87 0 0011.375 1.5a1.876 1.876 0 000 3.75zM5.75 4.5a2.24 2.24 0 002.242-2.25 2.247 2.247 0 10-4.492 0A2.247 2.247 0 005.75 4.5zm5.625 2.25c-1.373 0-4.125.69-4.125 2.063v.937c0 .412.338.75.75.75h6.75c.412 0 .75-.338.75-.75v-.938c0-1.372-2.752-2.062-4.125-2.062zM5.75 6C4.003 6 .5 6.878.5 8.625V9.75c0 .412.338.75.75.75h4.5V8.812c0-.637.247-1.754 1.777-2.602C6.875 6.075 6.245 6 5.75 6z","fill":"#fff"}})])
          )
        }
      }
    